import { Navigate } from 'react-router-dom';
import { isAdminAuthenticated } from '../lib/session';

export default function ProtectedRoute({ children }) {
  if (!isAdminAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
